function browserLocalStorage() {
    const jwtTokenKey = 'accessToken'
    const environment = 'Environment'
    function setToken(accessToken: string) {
        localStorage.setItem(jwtTokenKey, accessToken)
        document.cookie = `token=${accessToken}; Path=/`
    }

    function getToken(): string | null {
        const accessToken = localStorage.getItem(jwtTokenKey)
        if (accessToken) return accessToken
        return null
    }

    function removeToken() {
        localStorage.removeItem(jwtTokenKey)
    }

    function setEnvironment(env: 'demo' | 'stg' | 'freeze' | 'dev' | 'prod') {
        localStorage.setItem(environment, env)
    }

    function getEnvironment(): string | null {
        const env = localStorage.getItem(environment)
        if (env) return env
        return null
    }

    function removeEnvironment() {
        localStorage.removeItem(environment)
    }

    return {
        setToken,
        getToken,
        removeToken,
        setEnvironment,
        getEnvironment,
        removeEnvironment
    }
}

const BrowserLocalstorage = browserLocalStorage()

export { BrowserLocalstorage }
